import DefaultApplication from './DefaultApplication';

export default DefaultApplication;
